module.exports = __webpack_public_path__ + "img/fi-rr-eye-crossed.6034695c.svg";